export default __webpack_public_path__ + "static/media/section1-item-1-h5.612e691e.png";